
import Loading from 'vux/src/components/loading/index.vue'

import {mapState, mapActions} from 'vuex'
import cookie from 'vux/src/tools/cookie/index.js'

import querystring from 'vux/src/tools/querystring/index.js'
import dateFormat from 'vux/src/tools/date/format.js'



export default {
name: 'app',
data() {
return {
goBackList: [],
animateClass: 'bounceInRight',
transitionName: 'slide-left'
}
},
components: {
Loading
},
computed: {
...mapState({
change: state => state.change,
wxUserInfo: state => state.wxUserInfo
})
},
methods: {
...mapActions([
'isLogin'
])
},
watch: {
wxUserInfo(val){
if (val.phone) {
this.isLogin(true)
}
},
'$route'(to, from){




if (to.name == 'home') {
this.goBackList = []
this.animateClass = 'bounceInLeft'
this.transitionName = 'slide-left';

} else if (this.goBackList.indexOf(to.name) == -1) {

this.goBackList.push(to.name)

this.animateClass = 'bounceInRight'
this.transitionName = 'slide-right';

} else {

if (this.goBackList.indexOf(to.name) > this.goBackList.indexOf(from.name)) {
this.animateClass = 'bounceInRight'
this.transitionName = 'slide-right';


} else {
this.animateClass = 'bounceInLeft'
this.transitionName = 'slide-left';


}
}
}
},
mounted() {

},
created(){
console.log([
"                   _ooOoo_",
"                  o8888888o",
"                  88\" . \"88",
"                  (| -_- |)",
"                  O\\  =  /O",
"               ____/`---'\\____",
"             .'  \\\\|     |//  `.",
"            /  \\\\|||  :  |||//  \\",
"           /  _||||| -:- |||||-  \\",
"           |   | \\\\\\  -  /// |   |",
"           | \\_|  ''\\---/''  |   |",
"           \\  .-\\__  `-`  ___/-. /",
"         ___`. .'  /--.--\\  `. . __",
"      .\"\" '<  `.___\\_<|>_/___.'  >'\"\".",
"     | | :  `- \\`.;`\\ _ /`;.`/ - ` : | |",
"     \\  \\ `-.   \\_ __\\ /__ _/   .-` /  /",
"======`-.____`-.___\\_____/___.-`____.-'======",
"                   `=---='",
"^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^",
"              佛祖加持       永无BUG"
].join('\n'));
}
}



// WEBPACK FOOTER //
// ./src/App.vue